import React from 'react';
import { Box, } from '@waglabs/box-next';
import { useGetResponsivePropValue } from '@waglabs/use-get-responsive-prop-value';
import { cloudflareImageLoader, } from './loaders';
const loaderFnMap = {
    'cloudflare': cloudflareImageLoader,
};
export const Image = ({ srcSet, src, loader, loaderOptions, ...rest }) => {
    const imageSrc = useGetResponsivePropValue(src);
    const loaderImageSrc = loader && (typeof loader === 'function'
        ? loader(imageSrc, loaderOptions)
        : loaderFnMap[loader](imageSrc, loaderOptions));
    return (React.createElement(Box, Object.assign({ as: "img", src: loaderImageSrc || imageSrc, srcSet: srcSet }, rest)));
};
